<template>
  <div class="rc-member">
    <label class="item-name">{{initComponent.name}}</label>
    <div class="component-content">
      <el-button type="text"  :class="{'readonly': component.properties.readonly}" ><u>请选择</u></el-button>
    </div>
  </div>
</template>

<script>
import { componentMixin } from '../mixins'
export default {
  name: 'rc-member',
  props: ['initComponent'],
  mixins: [ componentMixin ],
  data () {
    return {
      component: this.initComponent
    }
  }
}
</script>

<style lang="scss">
  .rc-data-source-design {
    .readonly {
      color: #2A2929;
      u {
        text-decoration: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/components/member/rc-member.vue